/**
 * Admin Module
 *
 * Handles admin-specific functionality including:
 * - Restaurant management filters
 */

import { $, ready } from '../utils/dom.js';

// =============================================================================
// Restaurant Filters
// =============================================================================

const RESTAURANTS_BASE_URL = '/admin/restaurants';

/**
 * Apply status filter for restaurants
 * @param {HTMLSelectElement} select
 */
export function applyRestaurantStatusFilter(select) {
    const status = select.value;
    const params = new URLSearchParams();

    if (status) params.append('status', status);

    window.location.href = RESTAURANTS_BASE_URL + (params.toString() ? '?' + params.toString() : '');
}

/**
 * Clear restaurant filters
 */
export function clearRestaurantFilters() {
    window.location.href = RESTAURANTS_BASE_URL;
}

// =============================================================================
// Auto-Initialization
// =============================================================================

function initAdmin() {}

ready(initAdmin);

// Expose globally - use generic names that work with existing onclick handlers
window.applyStatusFilter = function(select) {
    // Detect which page we're on
    if (window.location.pathname.includes('/admin/restaurants')) {
        applyRestaurantStatusFilter(select);
    }
};

window.clearFilters = function() {
    if (window.location.pathname.includes('/admin/restaurants')) {
        clearRestaurantFilters();
    }
};

export default {
    applyRestaurantStatusFilter,
    clearRestaurantFilters
};
